import Select from 'react-select'

import { Box, HelperText, Label } from '../'

import { ClearIndicator, DropdownIndicator } from './components'

import { COLORS } from '@/constants'

const Size = 'big' | 'normal' | 'small'

const getHeight = (size) => {
    const heights = { small: 25, normal: 35, big: 45 }
    return heights[size] || heights.normal
}

const getMultiValueHeight = (size) => {
    const heights = { small: 22, normal: 26, big: 40 }
    return heights[size] || heights.normal
}

const getPadding = (size, isMulti) => {
    if (isMulti) {
        return size === 'big' ? '5px 8px' : '0 8px'
    }
    return '2px 8px'
}

const getIndicatorPadding = (size, isMulti) => {
    if (isMulti) {
        return size === 'big' ? 8 : size === 'small' ? 2 : 4
    }
    return size === 'small' ? 3 : size === 'big' ? 11 : 7
}

const colourStyles = (
        isError,
    size = 'normal',
    isMulti = false,
    ) => ({
    control: (styles, { isFocused, isDisabled }) => ({
        ...styles,
        minHeight: getHeight(size),
        height: isMulti ? 'auto' : getHeight(size),
        textAlign: 'left',
        outline: 'none',
        backgroundColor: COLORS.whiteDisabled,
        borderColor: isError
            ? COLORS.errorLight
            : isFocused
                ? COLORS.primary400
                : isDisabled
                    ? COLORS.grayInactive
                    : COLORS.grayDark,
        borderWidth: '1px',
        cursor: 'pointer', // Added for pointer cursor
        '&:hover': {
            borderColor: isError ? COLORS.errorLight : COLORS.primary400,
        },
        boxShadow: 'none',
        ...(isFocused && {
            borderColor: isError ? COLORS.errorLight : COLORS.primary400,
            borderWidth: '1px',
            outline: 'none',
        }),
    }),
    option: (styles, { isDisabled }) => ({
        ...styles,
        cursor: isDisabled ? 'default' : 'pointer', // Устанавливаем курсор "рука"
    }),
    valueContainer: styles => ({
        ...styles,
        padding: getPadding(size, isMulti),
    }),
    multiValue: (styles, { isDisabled }) => ({
        ...styles,
        height: getMultiValueHeight(size),
        backgroundColor: isDisabled ? COLORS.grayLight : COLORS.grayInactive,
    }),
    multiValueLabel: styles => ({
        ...styles,
        padding: size === 'big' ? '2px 2px' : '1px 2px',
    }),
    multiValueRemove: styles => ({
        ...styles,
        padding: size === 'big' ? '2px 2px' : '1px 2px',
    }),
    dropdownIndicator: styles => ({
        ...styles,
        padding: getIndicatorPadding(size, isMulti),
    }),
    clearIndicator: styles => ({
        ...styles,
        padding: getIndicatorPadding(size, isMulti),
    }),
    container: styles => ({ ...styles, width: '100%' }),
})


const SelectV2 = ({
   options = [],
   value,
   isClearable,
   isDisabled,
   onChange,
   onBlur,
   name,
   isLoading,
   isRtl = false,
   isMulti = false,
   isError = false,
   size = 'normal',
   helperText = '',
   isSearchable,
   placeholder = 'Select',
   label,
}) => {
    const handleChange = (
        newValue,
    ) => {
        onChange(
            (newValue) ??
        ({}),
    )
    }

    return (
        <Box direction="column" width="100%">
            {label && <Label label={label} />}

            <Select
                closeMenuOnSelect={!isMulti}
                placeholder={placeholder}
                isRtl={isRtl}
                isSearchable={isSearchable}
                name={name}
                isLoading={isLoading}
                value={value}
                options={options}
                isDisabled={isDisabled}
                isClearable={isClearable}
                menuPortalTarget={document.body}
                isMulti={isMulti}
                onBlur={onBlur}
                // @ts-ignore
                styles={{
                    menuPortal: base => ({ ...base, zIndex: 9999 }),
                    ...colourStyles(isError, size, isMulti),
                }}
                onChange={handleChange}
                components={{
                    DropdownIndicator,
                    IndicatorSeparator: () => null,
                    ClearIndicator,
                }}
                theme={theme => ({
                    ...theme,
                    borderRadius: 6,
                    colors: {
                        ...theme.colors,
                        primary: COLORS.primary400,
                    },
                })}
            />

            {helperText && <HelperText text={helperText} isError={isError} />}
        </Box>
    )
}

export { SelectV2 }
